var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-grid',{attrs:{"column-num":3}},_vm._l((_vm.images),function(value){return _c('van-grid-item',{key:value.id},[_c('van-image',{attrs:{"src":value.img,"fit":"contain","rel":"external nofollow"}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }